<template>
  <div v-safe-html="contentFooter"></div>
</template>

<script>
import { HtmlService } from '@/services'
import * as RouterPage from '@/constants/route-page'
import lineMixin from '@/mixins/line'

export default {
  mixins: [lineMixin],
  data() {
    return {
      contentFooter: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getFooterContent()
    })
  },
  watch: {
    '$route.path'(val) {
      document.querySelector('.footer__inner').style.paddingBottom = `${
        this.isShowButtonLine && [RouterPage.EC_LINE005_001, RouterPage.EC_LINE005_002].includes(val) ? 54 : 0
      }px`
    },
  },

  methods: {
    async getFooterContent() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.FOOTER)
      this.contentFooter = res.data
    },
  },
}
</script>
